import React from "react"
import { Twitter, Facebook, Reddit } from "react-social-sharing"
import { useStaticQuery, graphql } from "gatsby"

const SocialShare = ({ link }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          canonicalUrl
        }
      }
    }
  `)

  const rootUrl = data.site.siteMetadata.canonicalUrl
  const linkUrl = rootUrl + link
  return (
    <aside className="menu">
      <p className="menu-label">Share:</p>
      <Twitter small link={linkUrl} />
      <Facebook small link={linkUrl} />
      <Reddit small link={linkUrl} />
    </aside>
  )
}
export default SocialShare
